/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Clients_QInputs */

const en_platform_faq_clients_q = /** @type {(inputs: Platform_Faq_Clients_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do my clients have to install anything?`)
};

const pl_platform_faq_clients_q = /** @type {(inputs: Platform_Faq_Clients_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy moi podopieczni muszą coś instalować?`)
};

/**
* | output |
* | --- |
* | "Do my clients have to install anything?" |
*
* @param {Platform_Faq_Clients_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_clients_q = /** @type {((inputs?: Platform_Faq_Clients_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Clients_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_clients_q(inputs)
	return en_platform_faq_clients_q(inputs)
});